export default "__VITE_ASSET__MORmXGRr__"